export default __webpack_public_path__ + "static/media/grass.1d53db20.svg";